import mask from "@alpinejs/mask";
import isbot from "isbot";
import "./experiments";
import "./plan-clarity";
import {
    Alpine,
    Livewire,
} from "../../vendor/livewire/livewire/dist/livewire.esm";
import "../../vendor/masmerise/livewire-toaster/resources/js";

import line from "./alpine/graphs/line";
import soundPlayer from "./soundPlayer";
import imgFallback from "./alpine/img-fallback";
import chartCard from "./alpine/graphs/chart-card";
import toolRunner, { followerStats, audioTool } from "./tools/tool-runner";

Alpine.plugin(mask);
Alpine.data("line", line);
Alpine.data("soundPlayer", soundPlayer);
Alpine.data("imgFallback", imgFallback);
Alpine.data("chartCard", chartCard);
Alpine.data("toolRunner", toolRunner);
Alpine.data("followerStats", followerStats);
Alpine.data("audioTool", audioTool);

// Create a global Alpine store for sound player state
Alpine.store('soundPlayer', {
    currentPlayingId: null,
    setCurrentPlayingId(id) {
        this.currentPlayingId = id;
    }
});

Livewire.start();

let thisIsABot = false;
if (navigator && navigator.userAgent) {
    if (isbot(navigator.userAgent)) {
        thisIsABot = true;
    }
}

window.copyToClipboard = async (url) => {
    if (navigator.clipboard && window.isSecureContext) {
        // Navigator.clipboard is available
        try {
            await navigator.clipboard.writeText(url);
            return true; // Copying to clipboard was successful
        } catch (err) {
            console.error("Could not copy text: ", err);
            return false; // Copying to clipboard failed
        }
    } else {
        // Fallback for older browsers
        let textArea = document.createElement("textarea");
        textArea.value = url;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        // scroll back to top
        window.scrollTo(0, 0);
        try {
            let successful = document.execCommand("copy");
            document.body.removeChild(textArea);
            return successful; // Returns true or false based on execCommand success
        } catch (err) {
            console.error("Fallback: Oops, unable to copy", err);
            document.body.removeChild(textArea);
            return false; // Copying to clipboard failed
        }
    }
};

window.copyTableToClipboard = async (id) => {
    const table = document.querySelector("#" + id);
    let dataStr = "";
    for (const row of table.rows) {
        let rowData = [];
        for (const cell of row.cells) {
            // rowData.push(cell.innerText);
            // only push innerText of elements that don't have ".no-copy-table" class
            // if a cell a div with ".no-copy-table" class, copy the other elements inside the cell apart the one with the class
            let cellData = "";
            for (const el of cell.childNodes) {
                if (el.nodeType === 3) {
                    cellData += el.textContent;
                } else if (!el.classList.contains("no-copy-table")) {
                    cellData += el.innerText;
                }
            }
        }
        dataStr += rowData.join("\t") + "\n"; // Tab-separated values
    }
    return await window.copyToClipboard(dataStr);
};
